import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { CountDashboardRequestDTO } from 'submodules/nerit-aquatec-sdk/services/dashboard/dtos/requests/CountDashboardRequestDTO'
import { DashboardFilterRequestDTO } from 'submodules/nerit-aquatec-sdk/services/dashboard/dtos/requests/DashboardFilterRequestDTO'
import { DashboardConformityResponseDTO } from 'submodules/nerit-aquatec-sdk/services/dashboard/dtos/responses/DashboardConformityResponseDTO'
import { DashboardQAQCResponseDTO } from 'submodules/nerit-aquatec-sdk/services/dashboard/dtos/responses/DashboardQAQCResponseDTO'
import { WidgetOnlyValuesResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/features/dashboard/dtos/response/WidgetOnlyValuesResponseDTO'

export class DashboardRequests {

    public static CONTROLLER_ROOT = 'dashboard'
    public static GET_COUNTS = 'counts'
    public static GET_CONFORMITY = 'conformity'
    public static GET_QAQC = 'qaqc'

    static getCounts = (dto: CountDashboardRequestDTO): RequestConfigTP<WidgetOnlyValuesResponseDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DashboardRequests.CONTROLLER_ROOT}/${DashboardRequests.GET_COUNTS}`,
        method: HttpMethodEnum.GET,
        params: dto
    })

    static getConformity = (dto: DashboardFilterRequestDTO): RequestConfigTP<DashboardConformityResponseDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DashboardRequests.CONTROLLER_ROOT}/${DashboardRequests.GET_CONFORMITY}`,
        method: HttpMethodEnum.GET,
        params: dto
    })

    static getQAQC = (dto: DashboardFilterRequestDTO): RequestConfigTP<DashboardQAQCResponseDTO> => ({
        baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
        url: `${DashboardRequests.CONTROLLER_ROOT}/${DashboardRequests.GET_QAQC}`,
        method: HttpMethodEnum.GET,
        params: dto
    })

}
